export const CONTENT_STATUS: string[] = ["live", "draft", "rejected"];
